export default (text) => {
  return { __html: text }
}
